import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment/src/moment'
@Pipe({
    name: 'ago',
    standalone: false
})
export class AgoPipe implements PipeTransform {

  transform(value: any, args?: any): string {
    return moment(value).fromNow(true);
  }

}
